import React, { useMemo, useState } from 'react'
import { useLang } from '../lib/useLang'
import ModButton from '../ui/ModButton/ModButton'

export default function CodeSnippet({ language = 'bash', code = '' }) {
  const [copied, setCopied] = useState(false)
  const { t } = useLang()
  const pretty = useMemo(() => code, [code])
  const onCopy = async () => {
    try {
      // Try modern clipboard API first
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(code)
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
      } else {
        // Fallback for older browsers or insecure contexts
        const textarea = document.createElement('textarea')
        textarea.value = code
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        try {
          document.execCommand('copy')
          setCopied(true)
          setTimeout(() => setCopied(false), 1500)
        } finally {
          document.body.removeChild(textarea)
        }
      }
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }
  return (
    <div className='group relative overflow-hidden rounded-md border border-ink/10'>
      <div className='absolute right-2 top-2 opacity-0 transition group-hover:opacity-100'>
        <ModButton severity='secondary' size='sm' onClick={onCopy}>
          {copied ? t('codeSnippet.copied') : t('codeSnippet.copy')}
        </ModButton>
      </div>
      <pre className='overflow-auto bg-[#F5F1E8] p-3 text-xs'>
        <code className={`language-${language}`}>{pretty}</code>
      </pre>
    </div>
  )
}
